import React from 'react';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({novel_id, name, pic, desc}) => (
<div>
    <Link to={`/book/detail/${novel_id}`}>
        <div style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '128.6%',
            height: '0',
            backgroundImage: `url(${pic})`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
        }}>
            <div style={{
                position: 'absolute',
                bottom: '0px',
                fontSize: '12px',
                lineHeight: '24px',
                background: 'rgba(0, 0, 0, 0.4)',
                color: '#ffffff',
                textAlign: 'center',
                width: '100%',
            }}>
				<LinesEllipsis text={desc} maxLine={1} />
            </div>
        </div>
        <div style={{
            fontSize: '14px',
            lineHeight: '22px',
            color: '#333333',
            marginTop: '10px',
        }}>
			<LinesEllipsis text={name} maxLine={1} />
        </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_7.js